import { About } from '@/components/sections/about';

export function AboutPage() {
  return (
    <div className="container">
      <About />
    </div>
  );
}